import './ChatIntegration.scss';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';

declare global {
  interface Window {
    fcWidget: any;
    fcSettings: any;
  }
}

export default function ChatIntegration () {
  const user: any = useSelector((state: any) => state.authentication.get('user'));
  const client: any = useSelector((state: any) => state.authentication.get('client'));
  const clients: any = useSelector((state: any) => state.authentication.get('clients'));
  const hsIdentificationAccessToken: any = useSelector((state: any) => state.authentication.get('hsIdentificationAccessToken'));

  useEffect(() => {
    const widgetId = import.meta.env.REACT_APP_FRESHCHAT_TOKEN;
    const cdnUrl = import.meta.env.REACT_APP_FRESHCHAT_CDN_URL;
    if (!widgetId || !cdnUrl) return;

    function defined (val: any): val is string {
      return val !== null && val !== undefined && val !== '';
    }

    function setUserProperties () {
      try {
        if (user) {
          const email = user.get('email');
          const firstName = user.get('first_name');
          const lastName = user.get('last_name');

          if (defined(email)) window.fcWidget.user.setEmail(email);
          if (defined(firstName)) window.fcWidget.user.setFirstName(firstName);
          if (defined(lastName)) window.fcWidget.user.setLastName(lastName);
        }

        const customProps: Record<string, string> = {};
        if (defined(import.meta.env.MODE)) customProps.cf_environment = import.meta.env.MODE;
        if (defined(import.meta.env.REACT_APP_FOX_RELEASE_HASH)) customProps.cf_app_version = import.meta.env.REACT_APP_FOX_RELEASE_HASH;

        if (client) {
          const clientId = client.get('id');
          const clientName = client.get('name');
          if (defined(clientId)) customProps.cf_current_client_id = String(clientId);
          if (defined(clientName)) customProps.cf_current_client_name = String(clientName);
        }

        if (clients) {
          const clientIds = clients
            .filter((c: any) => c?.get)
            .map((c: any) => c.get('id'))
            .filter(defined)
            .join(', ');
          if (clientIds) customProps.cf_clients = clientIds;
        }

        if (user) {
          const userId = user.get('id');
          if (defined(userId)) customProps.cf_user_id = String(userId);
        }

        if (Object.keys(customProps).length) window.fcWidget.user.setProperties(customProps);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Freshchat: failed to set user properties', e);
      }
    }

    // Set onInit before loading the script to avoid race conditions
    window.fcSettings = {
      ...window.fcSettings,
      onInit: setUserProperties,
    };

    const scriptId = 'freshchat-lib';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.async = true;
      script.src = cdnUrl;
      script.setAttribute('chat', 'true');
      script.setAttribute('widgetId', widgetId);
      document.head.appendChild(script);
    } else if (window.fcWidget?.isInitialized()) {
      setUserProperties();
    }
  }, [user, client, clients]);

  function renderHubspotChat () {
    if (import.meta.env.REACT_APP_HUBSPOTCHAT_SCRIPT) {
      if (hsIdentificationAccessToken) {
        window['hsConversationsSettings'] = {
          identificationEmail: user.get('email'),
          identificationToken: hsIdentificationAccessToken
        };
      }

      return (<Helmet>
        <script type="text/javascript" id="hs-script-loader" async defer src={import.meta.env.REACT_APP_HUBSPOTCHAT_SCRIPT}></script>
      </Helmet>);
    }

    return null;
  }

  return (<>
    {renderHubspotChat()}
  </>);
}
